import { inject } from '@angular/core';
import {
  CanActivateFn,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { AuthGuardService, JwtHelperService } from '@alfresco/adf-core';
import { WkAuthenticationService } from '../services';

const ticketChangeRedirect = (
  event: StorageEvent,
  authGuardBaseService: AuthGuardService,
  url: string
): void => {
  if (event.newValue) {
    authGuardBaseService.navigate(url);
  } else {
    window.location.reload();
  }
};

const ticketChangeHandler = (
  event: StorageEvent,
  authGuardBaseService: AuthGuardService,
  jwtHelperService: JwtHelperService,
  url: string
): void => {
  if (
    event.newValue !== event.oldValue &&
    (event.key.includes('ticket-ECM') || event.key.includes('ticket-BPM'))
  ) {
    ticketChangeRedirect(event, authGuardBaseService, url);
  }

  if (
    event.key.endsWith(JwtHelperService.USER_ACCESS_TOKEN) &&
    jwtHelperService.getValueFromToken(
      event.newValue,
      JwtHelperService.USER_PREFERRED_USERNAME
    ) !==
      jwtHelperService.getValueFromToken(
        event.oldValue,
        JwtHelperService.USER_PREFERRED_USERNAME
      )
  ) {
    ticketChangeRedirect(event, authGuardBaseService, url);
  }
};

export const WkAuthGuard: CanActivateFn = async (
  _: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<boolean> => {
  const router = inject(Router);
  const jwtHelperService = inject(JwtHelperService);
  const authGuardBaseService = inject(AuthGuardService);
  const authenticationService = inject(WkAuthenticationService);

  window.addEventListener('storage', (event: StorageEvent) =>
    ticketChangeHandler(
      event,
      authGuardBaseService,
      jwtHelperService,
      router.url
    )
  );

  if (
    authenticationService.isLoggedIn() ||
    authGuardBaseService.withCredentials
  ) {
    return true;
  }

  return authGuardBaseService.redirectToUrl(state.url);
};
